// removed by extract-text-webpack-plugin
module.exports = {"hiddenTabs":"_3cPNJKmK","button":"_2lgmCgzw","pickUpTimeText":"_4IrmW0-c","pickUpTimeInput":"_1bE3XyXq","pickUpTimeError":"_1i-1NzvU","collapse":"_3MP7Y2Pz"};


//////////////////
// WEBPACK FOOTER
// ./app/orders/containers/order-create/order-create.styles.scss
// module id = 709
// module chunks = 0